import { BatchOwner, BatchCounty, BatchMount } from '@/Domain/Batch'

export class BatchLocation {
  private _mount: BatchMount
  private _owner: BatchOwner
  private _county: BatchCounty | null

  constructor (mount: BatchMount, owner: BatchOwner, county: BatchCounty | null) {
    this._mount = mount
    this._owner = owner
    this._county = county
  }

  mount (): string {
    return this._mount.name()
  }

  owner (): string {
    return this._owner.name()
  }

  county (): string {
    return this._county === null ? '' : this._county.name()
  }
}
